import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery } from '../../../hoc/withGraphql';
import getAdminAuditLogs from './getAdminAuditLogs.graphql';

const RED = '#D32F2F';
const PAGE_SIZE = 25;

class AuditLog extends Component {
  constructor(props) {
    super(props);
    this.state = { eventType: '', adminEmail: '', search: '', currentPage: 1 };
  }

  vars() {
    return {
      currentPage: this.state.currentPage,
      eventType: this.state.eventType || undefined,
      adminEmail: this.state.adminEmail || undefined,
      search: this.state.search || undefined,
    };
  }

  refetch = () => this.props.logs.refetch(this.vars());
  apply = () => this.setState({ currentPage: 1 }, this.refetch);
  go = (delta) => this.setState((s) => ({ currentPage: Math.max(1, s.currentPage + delta) }), this.refetch);

  render() {
    const list = (this.props.logs && this.props.logs.getAdminAuditLogs) || {};
    const rows = list.results || [];
    const loading = this.props.logs && this.props.logs.loading;
    const totalPages = Math.max(1, Math.ceil((list.count || 0) / PAGE_SIZE));

    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 8 });
    const th = { padding: 10, textAlign: 'left' };
    const td = { padding: 10, borderTop: '1px solid #f0f0f0', fontSize: 13 };
    const badge = (e) => {
      const c = { login: '#2E7D32', logout: '#9E9E9E', action: '#1565C0', page_view: '#7E57C2' }[e] || '#9E9E9E';
      return { padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 700, color: '#fff', background: c };
    };

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">Admin Activity Log</h1>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 14 }}>
          <select style={input} value={this.state.eventType} onChange={(e) => this.setState({ eventType: e.target.value })}>
            <option value="">All events</option>
            <option value="login">Logins</option>
            <option value="logout">Logouts</option>
            <option value="action">Actions</option>
            <option value="page_view">Page views</option>
          </select>
          <input style={input} placeholder="Admin email" value={this.state.adminEmail} onChange={(e) => this.setState({ adminEmail: e.target.value })} />
          <input style={input} placeholder="Search action/path…" value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} />
          <button style={btn(RED)} onClick={this.apply}>Apply</button>
        </div>

        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead><tr style={{ background: '#fafafa' }}>
              <th style={th}>When</th><th style={th}>Admin</th><th style={th}>Event</th><th style={th}>Action / Page</th><th style={th}>IP</th>
            </tr></thead>
            <tbody>
              {loading && <tr><td style={td} colSpan={5}>Loading…</td></tr>}
              {!loading && rows.length === 0 && <tr><td style={td} colSpan={5}>No activity recorded yet.</td></tr>}
              {!loading && rows.map((r) => (
                <tr key={r.id}>
                  <td style={td}>{r.createdAt ? r.createdAt.replace('T', ' ').slice(0, 19) : '—'}</td>
                  <td style={td}>{r.adminEmail || r.adminId || '—'}</td>
                  <td style={td}><span style={badge(r.eventType)}>{r.eventType}</span></td>
                  <td style={td}>{r.action || r.path || '—'}</td>
                  <td style={td}>{r.ip || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', gap: 12 }}>
          <button style={btn(RED)} disabled={this.state.currentPage <= 1} onClick={() => this.go(-1)}>Prev</button>
          <span>Page {this.state.currentPage} / {totalPages} ({list.count || 0} events)</span>
          <button style={btn(RED)} disabled={this.state.currentPage >= totalPages} onClick={() => this.go(1)}>Next</button>
        </div>
      </div>
    );
  }
}

export default compose(
  withQuery(getAdminAuditLogs, { name: 'logs', options: { variables: { currentPage: 1 }, fetchPolicy: 'network-only', ssr: false } }),
)(AuditLog);
